import $ from 'jquery';
import 'slick-carousel';

$('.cascade-nav').on('click', function() {
  const group = $(this).data('cascade-group');
  const last = $(`.cascade-group-${group}`).length;
  let next = $(this).attr('data-next');
  if (next <= last) {
    const $pane = $(`#cascade-${next}.cascade-group-${group}`);
    $pane.addClass('is-active');
    if ( next == last ) {
      $(this).addClass('completed');
    }
    $(this).attr('data-next', ++next);
  } 
});
